import React from 'react';
import {Form} from 'react-form';
import {connect} from 'react-redux';
import async from 'async';

import APPCONFIG from 'constants/Config';
import AuthService from 'services/AuthService';
import UserService from 'services/UserService';
import XService from 'services/XService';

import ConfigurationService from "services/ConfigurationService";
import {FormGroup, Text} from 'components/FormElements/';
import {required} from 'constants/InputErrors';
import {loginUser, logoutUser, toggleAlertError, toggleLoading, updateSettings, toggleApiError} from 'stores/actions';

class Login extends React.Component {
  constructor() {
    super();

    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    const casUrl = process.env.CAS_URL;
    const casUrlLogin = `${casUrl}${process.env.CAS_LOGIN}` ;
    const casUrlLogout = `${casUrl}${process.env.CAS_LOGOUT}` ;
    const casUrlValidate = `${casUrl}${process.env.CAS_VALIDATE}` ;
    var bTicket = this.props.location.search.indexOf('ticket=')===-1 ? false : true;
    const bLogin = this.props.location.pathname === '/login' ? true : false;
    const urlParams = new URLSearchParams(window.location.search);
    const ticket = urlParams.get('ticket');
    const bCAS =  casUrl !== '' ? true : false;
    const smmUrlService = window.location.href.split("?", 1)[0];
    
    //const xCode = urlParams.get('code')
    //const xState= urlParams.get('state')
    //console.log('state', xState);
    //console.log('code', xCode);
    //TODO LIMPIAR URl 
    

    //LLAMAR API
    /* if (xCode) {
      XService.getCode(xCode).then((response) => {
        if (response.errors) console.log('response.error', response.errors);

        console.log('sponse.data', response.data);
        return
      })
    }*/
    if ( bLogin ) { this.props.history.push( '/' )}
    if (bCAS && !bLogin) {
      if ((!bTicket) ) {
        window.location.replace( `${casUrlLogin}?service=${smmUrlService}` );
      } else {
        const credentials = {
          username:'',
          password:'',
          ticket: ticket,
          urlCasValidate: casUrlValidate,
          service: smmUrlService
        }
        this.submitForm( credentials ) 
      }
    } else if (bCAS &&  bLogin) {
      window.location.replace( `${casUrlLogout}?service=${ smmUrlService.replace('#/login','') }` );
    }

    if( this.props.accessToken ) {
      this.props.logoutUser();
    }

    if( this.props.isLoading ) {
      this.props.toggleLoading( false );
    }
  }

  submitForm( credentials ) {
    this.props.toggleLoading( true );

    async.waterfall( [
      this.loginUser.bind( this, credentials ),
      this.getCurrentUser,
      this.getSettings,
      this.verifyComponentsStatus,
      this.verifyApiStatus,
    ], ( error, results ) => {
      this.props.toggleLoading( false );
      if( error ) return this.props.toggleAlertError( 'Invalid username or password' );
      this.props.loginUser( results.user );
      this.props.updateSettings( {
        apiStatus: results.api,
        networkSettings: results.networkSettings,
        extraMenu: results.extraMenu,
        externalAuthenticationRequired: results.externalAuthenticationRequired,
        imsDomainActive: results.imsDomainActive,
        chatActive: results.chatActive,
        phoneActive: results.phoneActive,
        reportActive: results.reportActive,
        clientFolderIframe: results.clientFolderIframe,
        dateFormat:  results.dateFormat,
        dateTimeFormat:  results.dateTimeFormat,
        closeOnReply: results.closeOnReply,
        externalCodes: results.externalCodes,
        externalApiUrl: results.externalApiUrl,
        externalCustomer: results.externalCustomer,
        googleMapKey: results.googleMapKey,
        uploadFile: results.uploadFile,
        documentHelpUrl: results.documentHelpUrl,
        urlWeb : results.urlWeb

      } );

      if ( results.user.afterDashboard ) this.props.history.push( '/' );
      else if ( results.user.afterPanel ) this.props.history.push( '/agent' );
      else if ( this.props.location.pathname === '/login' ) this.props.history.push( '/' );
      window.location.reload();
    } );
  };

  loginUser( credentials, cb ) {
    AuthService.login( credentials ).then( ( response ) => {
      if( response.errors ) return cb( response.errors );

      return cb( null, response.data )
    } )
  }

  getCurrentUser( loginData, cb ) {
    UserService.getCurrentUser(  loginData.access_token ).then( ( response ) => {
      if( response.errors ) return cb( response.errors );
      if( !response.data.roles || !response.data.roles.length || !response.data.roles[0] )
        return cb( 'This user can not access to the application' );

      let {
        roles, name, lastname,
        filterFacebook, filterTwitter, filterEmail, filterMy, filterPhone,filterWalkIn,
        afterDashboard, afterPanel, beforeDelete, languageEnabled, id,
        filterLastService, filterLastWords, filterLastCategory, filterLastFrom,
        filterLastViaSocialType, filterLastTwHashTag, filterLastTwAccount, username, externalAuthentication,
        chatFilterLastService, chatFilterLastCategory, chatFilterLastWords, chatFilterLastFrom,
        agentSocialTab, hostname, emailUsername, emailPassword, clientVersion
      } = response.data;
      if( filterLastCategory )
        filterLastCategory = filterLastCategory.split( ',' ).map( item => Number( item ) );
      return cb( null, {
        name, lastname, roles,
        afterDashboard, afterPanel, beforeDelete, languageEnabled,filterWalkIn,
        filterFacebook, filterTwitter, filterPhone, filterEmail,
        filterMy, filterLastService, filterLastWords, filterLastCategory, filterLastFrom,
        filterLastViaSocialType, filterLastTwHashTag, filterLastTwAccount, username, externalAuthentication,
        chatFilterLastService, chatFilterLastCategory, chatFilterLastWords, chatFilterLastFrom,
        agentSocialTab, hostname, emailUsername, emailPassword, clientVersion,
        userId: id,
        id: id, ...loginData
      } )
    } )
  }

  getSettings = ( data, cb ) => {
    ConfigurationService.getConfigurations( data.access_token ).then( ( response ) => {
      if( response.errors ) return cb( null, response.errors );
      //TODO: Si no hay configuracion mostrar un error...
      const responseData = response.data.data[0];
      return cb( null, {
        user: data,
        networkSettings: {
          facebookLimit: responseData.facebookCharactersLimit ? responseData.facebookCharactersLimit : -1,
          twitterLimit: responseData.twitterCharactersLimit ? responseData.twitterCharactersLimit : -1,
          emailLimit: responseData.emailCharactersLimit ? responseData.emailCharactersLimit : -1,
          smsLimit: responseData.smsCharactersLimit ? responseData.smsCharactersLimit : 60,
          cti: responseData.cti,
        },
        extraMenu: responseData.extraMenu,
        externalAuthenticationRequired: responseData.externalAuthenticationRequired,
        imsDomainActive: responseData.imsDomainActive,
        chatActive: responseData.chatActive,
        closeOnReply: responseData.closeOnReply,
        phoneActive: responseData.phoneActive,
        reportActive: responseData.reportActive,
        externalCodes: responseData.externalCodes,
        externalApiUrl: responseData.externalApiUrl,
        documentHelpUrl: responseData.documentHelpUrl || 'https://cencoapps.com/media/smmHelp.pdf',
        externalCustomer: responseData.externalCustomer,
        googleMapKey: responseData.googleMapKey || '',
        uploadFile: responseData.uploadFile || false,
        clientFolderIframe: responseData.clientFolderIframe || false,
        dateFormat:  responseData.dateFormat ? responseData.dateFormat : 'DD/MM/YYYY',
        dateTimeFormat: responseData.dateTimeFormat ? responseData.dateTimeFormat : 'DD/MM/YYYY',
        urlWeb : responseData.urlWeb || 'https://cc.cencoapps.com/'
      } );
    } );
  };

  verifyApiStatus = ( data, cb ) => {
    return cb( null, { ...data, api2: {} } );
    ConfigurationService.getAppConfiguration( data.user.access_token ).then( ( response ) => {
      if( response.errors ) return cb( null, { ...data, api2: { incmsApiStatus: 'KO' } } );
      return cb( null, { ...data, api2: response.data } );
    } );
  };
  
  verifyComponentsStatus = ( data, cb ) => {
    //return cb( null, { ...data, api: {} } );

    ConfigurationService.getComponentStatus( data.user.access_token ).then( ( response ) => {
      if( response.errors ) return cb( null, { ...data, api: {
        dbStatus: 'KO',
        whatsappStatus: 'KO',
        incmsStatus: 'KO',
        facebookStatus: 'KO',
        twitterStatus: 'KO',
        emailStatus: 'KO',
        phoneStatus: 'OK', 
        incmsApiStatus: 'KO' 
      } } );
      const whatsappStatus = _.find(response.data.data, { 'code': 'whatsapp_status'});
      const dbStatus = _.find(response.data.data, { 'code': 'db_status'});
      const incmsStatus = _.find(response.data.data, { 'code': 'incms_status'});
      const facebookStatus = _.find(response.data.data, { 'code': 'facebook_status'});
      const twitterStatus = _.find(response.data.data, { 'code': 'twitter_status'});
      const emailStatus = _.find(response.data.data, { 'code': 'email_status'});
      //const smsStatus = _.find(response.data.data, { 'code': 'sms_status'});
      let message = '';
      if ( incmsStatus && incmsStatus.status && incmsStatus.status === 'KO') {
        message += ' - External Api,'
      }
      
      if (dbStatus && dbStatus.status && dbStatus.status === 'KO') {
        message += ' - Database,'
      }
      //if (whatsappStatus.status === 'KO') {
      //  message += 'Whatsapp,'
      //}
      if (facebookStatus && facebookStatus.status && facebookStatus.status === 'KO') {
        message += ' - Facebook'
      }
      if ( twitterStatus && twitterStatus.status && twitterStatus.status === 'KO') {
        message += ' - Twitter'
      }
      if (emailStatus && emailStatus.status && emailStatus.status === 'KO') {
        message += ' - Email'
      }
      if ( response.data.total === 0) {
        message += ' - You must run the service monitoring job'
      }
      if ( message !== '' ) {
        message += ' ';
        message = 'The following services have problems:' + message;
      }
      this.props.toggleApiError( message )
      return cb( null, { ...data, api: {
        dbStatus: dbStatus && dbStatus.status ? dbStatus.status : 'KO' ,
        whatsappStatus: whatsappStatus && whatsappStatus.status ? whatsappStatus.status : 'KO',
        incmsApiStatus: incmsStatus && incmsStatus.status ? incmsStatus.status : 'KO',
        facebookStatus: facebookStatus && facebookStatus.status ? facebookStatus.status : 'KO' ,
        twitterStatus: twitterStatus && twitterStatus.status ? twitterStatus.status : 'KO' ,
        emailStatus:  emailStatus && emailStatus.status ? emailStatus.status : 'KO' ,
        //phoneStatus: smsStatus.status,
      } } );
    } );
  };

  render() {
    return (
      <div className="page-login">
        <div className="main-body">
          <div className="body-inner">
            <div className="card bg-white">
              <div className="card-content">
                <section className="text-center">
                  <img src="assets/images/logo_smm_minsait.png" width={200} className="mb-3"/>
                </section>

                <Form
                  onSubmit={this.submitForm}
                  validate={values => {
                    return {
                      username: required( values.username ),
                      password: required( values.password ),
                    }
                  }}
                >
                  {( { submitForm } ) =>
                    <form onSubmit={submitForm}>
                      <div className="form-group">
                        <Text field="username" className="form-control" placeholder="username" autoComplete="username" />
                      </div>
                      <div className="form-group mt-3">
                        <Text field="password" className="form-control" placeholder="password" type="password" autoComplete="current-password" />
                      </div>

                      <div className="text-right mt-3">
                        <button type="submit" className="btn btn-info text-uppercase">Login</button>
                      </div>
                    </form>
                  }
                </Form>
              </div>
            </div>

            <div className="additional-info">
              <a href="#/forgot-password">Forgot your password?</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ( state, ownProps ) => ({
  accessToken: state.user.access_token,
  isLoading: state.settings.isLoading,
});

const mapDispatchToProps = dispatch => ({
  loginUser: ( user ) => {
    dispatch( loginUser( user ) );
  },
  logoutUser: () => {
    dispatch( logoutUser() );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  updateSettings: ( data ) => {
    dispatch( updateSettings( data ) );
  },
  toggleApiError: ( apiErrorMessage ) => {
    dispatch( toggleApiError( apiErrorMessage ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Login );



// WEBPACK FOOTER //
// ./routes/login/index.js